"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyNotice = PrivacyNotice;
var _react = _interopRequireDefault(require("react"));
var _PrivacyNoticeContent = require("./PrivacyNoticeContent");
/**
 * PrivacyNotice component.
 *
 * Render the expandable card-data privacy statement.
 *
 * @param {object} props - Component props.
 * @returns {React.ReactElement} Privacy notice.
 */
function PrivacyNotice(_ref) {
  var _ref$available = _ref.available,
    available = _ref$available === void 0 ? false : _ref$available;
  if (!available) return null;
  return /*#__PURE__*/_react["default"].createElement(_PrivacyNoticeContent.PrivacyNoticeContent, {
    "data-sentry-element": "PrivacyNoticeContent",
    "data-sentry-component": "PrivacyNotice",
    "data-sentry-source-file": "PrivacyNotice.tsx"
  });
}